var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadArrowBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 14.4385L13.8333 14.4385C14.2753 14.4385 14.6992 14.2629 15.0118 13.9503C15.3243 13.6378 15.4999 13.2138 15.4999 12.7718L15.4999 2.77181C15.4999 2.32978 15.3243 1.90586 15.0118 1.5933C14.6992 1.28074 14.2753 1.10514 13.8333 1.10514L12.1666 1.10514M7.16659 11.9385L11.3333 7.77181M11.3333 7.77181L7.16659 3.60514M11.3333 7.77181L1.33325 7.77181",
    stroke: "#1963DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadArrowBlue);
export default __webpack_public_path__ + "static/media/read-arrow-blue.59741c807e4786c9be585a3f41f8fa84.svg";
export { ForwardRef as ReactComponent };